import { Contact } from '../interfaces/entities/contact'

export const contacts: Contact[] = [
  {
    id: '1',
    name: 'Contact 1',
  },
  {
    id: '2',
    name: 'Contact 2',
  },
  {
    id: '3',
    name: 'Contact 3',
    phone: '12541-558',
    email: 'heike@gmail.com',
  },
  {
    id: '4',
    name: 'Contact 4',
  },
]
